var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _g, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProjectImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 751,
    height: 494,
    viewBox: "0 0 751 494",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M533.207 135.023C539.072 137.288 543.64 141.348 545.944 146.344C545.944 146.344 544.923 133.597 552.072 128.525C552.072 128.525 545.599 132.754 544.232 138.954C541.133 136.74 537.284 135.367 533.207 135.023Z",
    fill: "#263238"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M501.41 103.068C501.41 103.068 513.276 110.682 516.52 117.7C516.52 117.7 518.338 110.174 526.929 107.917C524.895 107.892 522.885 108.276 521.071 109.037C519.258 109.797 517.696 110.911 516.52 112.282C512.811 107.952 507.513 104.722 501.41 103.068Z",
    fill: "#263238"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M488.734 136.188C488.734 136.188 498.452 134.948 503.108 139.834C503.108 139.834 500.225 132.543 503.108 127.607C503.108 127.607 499.263 129.641 500.6 136.969C500.6 136.969 496.905 133.82 488.734 136.188Z",
    fill: "#263238"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M751 405.977H0V406.287H751V405.977Z",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M206.766 414.42H157.02V414.73H206.766V414.42Z",
    fill: "#EBEBEB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M318.259 425.777H257.053V426.087H318.259V425.777Z",
    fill: "#EBEBEB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M155.517 421.898H78.7949V422.208H155.517V421.898Z",
    fill: "#EBEBEB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M675.75 416.504H535.854V416.814H675.75V416.504Z",
    fill: "#EBEBEB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M479.803 421.736H416.373V422.046H479.803V421.736Z",
    fill: "#EBEBEB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M355.973 350.672H65.952C63.68 350.669 61.5024 349.921 59.8973 348.594C58.2921 347.266 57.3906 345.467 57.3906 343.592V7.0184C57.4104 5.15347 58.3207 3.37029 59.9237 2.05619C61.5267 0.742088 63.693 0.00319472 65.952 0H355.973C358.248 0 360.429 0.745969 362.038 2.0738C363.646 3.40163 364.55 5.20256 364.55 7.0804V343.592C364.55 345.469 363.646 347.27 362.038 348.598C360.429 349.926 358.248 350.672 355.973 350.672ZM65.952 0.248001C63.7796 0.251286 61.6975 0.966041 60.1628 2.23538C58.6281 3.50472 57.7661 5.22492 57.7661 7.0184V343.592C57.7661 345.385 58.6281 347.105 60.1628 348.375C61.6975 349.644 63.7796 350.359 65.952 350.362H355.973C358.146 350.355 360.227 349.64 361.763 348.372C363.3 347.103 364.166 345.385 364.174 343.592V7.0184C364.166 5.22479 363.3 3.50651 361.763 2.23822C360.227 0.969941 358.146 0.254535 355.973 0.248001H65.952Z",
    fill: "#EBEBEB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M680.868 350.672H390.832C388.56 350.665 386.383 349.917 384.777 348.591C383.17 347.265 382.264 345.467 382.256 343.592V7.0184C382.28 5.15234 383.193 3.36918 384.799 2.05542C386.404 0.741655 388.572 0.00315988 390.832 0H680.868C683.125 0.00645358 685.287 0.746789 686.887 2.06054C688.487 3.3743 689.395 5.15561 689.415 7.0184V343.592C689.417 344.52 689.197 345.439 688.769 346.297C688.34 347.156 687.712 347.936 686.918 348.593C686.124 349.251 685.182 349.773 684.144 350.129C683.106 350.486 681.993 350.67 680.868 350.672ZM390.832 0.248001C388.66 0.254535 386.578 0.969941 385.042 2.23822C383.506 3.50651 382.639 5.22479 382.631 7.0184V343.592C382.639 345.385 383.506 347.103 385.042 348.372C386.578 349.64 388.66 350.355 390.832 350.362H680.868C683.041 350.355 685.122 349.64 686.659 348.372C688.195 347.103 689.061 345.385 689.069 343.592V7.0184C689.061 5.22479 688.195 3.50651 686.659 2.23822C685.122 0.969941 683.041 0.254535 680.868 0.248001H390.832Z",
    fill: "#EBEBEB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M322.51 66.0307H442.76C442.76 66.0307 435.46 56.5819 422.979 61.3063C422.979 61.3063 420.635 51.3863 412.57 51.2127C410.361 51.0775 408.153 51.4741 406.212 52.3545C404.271 53.2349 402.681 54.5612 401.635 56.1727C401.635 56.1727 392.263 44.1447 377.949 46.7239C373.965 47.3595 370.32 49.0039 367.521 51.4283C364.721 53.8528 362.906 56.937 362.328 60.2523C362.328 60.2523 340.954 51.2127 322.51 66.0307Z",
    fill: "#FAFAFA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M102.736 204.241H222.896C222.896 204.241 215.612 194.779 203.115 199.504C203.115 199.504 200.772 189.584 192.706 189.41C190.499 189.281 188.293 189.681 186.354 190.56C184.414 191.44 182.823 192.763 181.772 194.37C181.772 194.37 172.414 182.33 158.1 184.909C154.137 185.554 150.513 187.198 147.729 189.614C144.945 192.031 143.137 195.1 142.554 198.4C142.554 198.4 121.211 189.41 102.736 204.241Z",
    fill: "#FAFAFA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M559.568 137.406H679.803C679.803 137.406 672.519 127.957 660.022 132.681C660.022 132.681 657.694 122.761 649.613 122.588C647.407 122.455 645.202 122.853 643.264 123.733C641.326 124.613 639.739 125.938 638.694 127.548C638.694 127.548 629.321 115.52 615.007 118.099C611.024 118.735 607.379 120.379 604.579 122.803C601.78 125.228 599.965 128.312 599.386 131.627C599.386 131.627 578.043 122.588 559.568 137.406Z",
    fill: "#FAFAFA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M552.153 78.4044C553.704 73.0001 549.655 67.5809 543.109 66.3004C536.562 65.0199 529.998 68.3629 528.447 73.7673C526.896 79.1716 530.945 84.5908 537.492 85.8713C544.038 87.1519 550.602 83.8088 552.153 78.4044Z",
    fill: "#F0F0F0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2441 137.406H211.479C211.479 137.406 204.27 127.957 191.698 132.681C191.698 132.681 189.355 122.761 181.289 122.588C179.083 122.455 176.878 122.853 174.94 123.733C173.002 124.613 171.414 125.938 170.37 127.548C170.37 127.548 160.997 115.52 146.683 118.099C142.699 118.735 139.055 120.379 136.255 122.803C133.456 125.228 131.641 128.312 131.062 131.627C131.062 131.627 109.719 122.588 91.2441 137.406Z",
    fill: "#FAFAFA"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M306.832 167.488H179.342V372.894H306.832V167.488Z",
    fill: "#E6E6E6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M283.656 167.488H179.342V372.894H283.656V167.488Z",
    fill: "#F0F0F0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M308.334 167.488H176.594V170.836H308.334V167.488Z",
    fill: "#E0E0E0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M308.334 160.779H176.594V164.127H308.334V160.779Z",
    fill: "#E0E0E0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M305.57 164.127H179.342V167.475H305.57V164.127Z",
    fill: "#F0F0F0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M208.826 179.578H189.24V195.748H208.826V179.578Z",
    fill: "#E6E6E6"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M208.826 179.578H190.967V195.748H208.826V179.578Z",
    fill: "#F5F5F5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M238.506 179.578H218.92V195.748H238.506V179.578Z",
    fill: "#E6E6E6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M238.509 179.578H220.65V195.748H238.509V179.578Z",
    fill: "#F5F5F5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M268.17 179.578H248.584V195.748H268.17V179.578Z",
    fill: "#E6E6E6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M268.171 179.578H250.312V195.748H268.171V179.578Z",
    fill: "#F5F5F5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M208.826 203.398H189.24V219.568H208.826V203.398Z",
    fill: "#E6E6E6"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M208.826 203.398H190.967V219.568H208.826V203.398Z",
    fill: "#F5F5F5"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M238.506 203.398H218.92V219.568H238.506V203.398Z",
    fill: "#E6E6E6"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M238.509 203.398H220.65V219.568H238.509V203.398Z",
    fill: "#F5F5F5"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M268.17 203.398H248.584V219.568H268.17V203.398Z",
    fill: "#E6E6E6"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M268.171 203.398H250.312V219.568H268.171V203.398Z",
    fill: "#F5F5F5"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M208.826 247.008H189.24V263.177H208.826V247.008Z",
    fill: "#E6E6E6"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M208.826 247.008H190.967V263.177H208.826V247.008Z",
    fill: "#F5F5F5"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M238.506 247.008H218.92V263.177H238.506V247.008Z",
    fill: "#E6E6E6"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M238.509 247.008H220.65V263.177H238.509V247.008Z",
    fill: "#F5F5F5"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M268.17 247.008H248.584V263.177H268.17V247.008Z",
    fill: "#E6E6E6"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M268.171 247.008H250.312V263.177H268.171V247.008Z",
    fill: "#F5F5F5"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M208.826 270.828H189.24V286.998H208.826V270.828Z",
    fill: "#E6E6E6"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M208.826 270.828H190.967V286.998H208.826V270.828Z",
    fill: "#F5F5F5"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M238.506 270.828H218.92V286.998H238.506V270.828Z",
    fill: "#E6E6E6"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M238.509 270.828H220.65V286.998H238.509V270.828Z",
    fill: "#F5F5F5"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M268.17 270.828H248.584V286.998H268.17V270.828Z",
    fill: "#E6E6E6"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M268.171 270.828H250.312V286.998H268.171V270.828Z",
    fill: "#F5F5F5"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M208.826 319.301H189.24V335.47H208.826V319.301Z",
    fill: "#E6E6E6"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M208.826 319.301H190.967V335.47H208.826V319.301Z",
    fill: "#F5F5F5"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M238.506 319.301H218.92V335.47H238.506V319.301Z",
    fill: "#E6E6E6"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M238.509 319.301H220.65V335.47H238.509V319.301Z",
    fill: "#F5F5F5"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M268.17 319.301H248.584V335.47H268.17V319.301Z",
    fill: "#E6E6E6"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M268.171 319.301H250.312V335.47H268.171V319.301Z",
    fill: "#F5F5F5"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M208.826 343.121H189.24V359.291H208.826V343.121Z",
    fill: "#E6E6E6"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M208.826 343.121H190.967V359.291H208.826V343.121Z",
    fill: "#F5F5F5"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M238.506 343.121H218.92V359.291H238.506V343.121Z",
    fill: "#E6E6E6"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M238.509 343.121H220.65V359.291H238.509V343.121Z",
    fill: "#F5F5F5"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M268.17 343.121H248.584V359.291H268.17V343.121Z",
    fill: "#E6E6E6"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M268.171 343.121H250.312V359.291H268.171V343.121Z",
    fill: "#F5F5F5"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M306.832 230.938H179.342V232.438H306.832V230.938Z",
    fill: "#E0E0E0"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M306.832 305.5H179.342V307H306.832V305.5Z",
    fill: "#E0E0E0"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M157.817 228.992H69.6348V406.139H157.817V228.992Z",
    fill: "#E0E0E0"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M132.704 228.992H69.6348V406.139H132.704V228.992Z",
    fill: "#F0F0F0"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6052 243.549H76.1289V252.96H99.6052V243.549Z",
    fill: "#E6E6E6"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6017 243.549H77.6875V252.96H99.6017V243.549Z",
    fill: "#F5F5F5"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M126.758 243.549H103.281V252.96H126.758V243.549Z",
    fill: "#E6E6E6"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M126.741 243.549H104.842V252.96H126.741V243.549Z",
    fill: "#F5F5F5"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6052 261.256H76.1289V270.667H99.6052V261.256Z",
    fill: "#E6E6E6"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6017 261.256H77.6875V270.667H99.6017V261.256Z",
    fill: "#F5F5F5"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M126.758 261.256H103.281V270.667H126.758V261.256Z",
    fill: "#E6E6E6"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M126.741 261.256H104.842V270.667H126.741V261.256Z",
    fill: "#F5F5F5"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6052 283.887H76.1289V293.298H99.6052V283.887Z",
    fill: "#E6E6E6"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6017 283.887H77.6875V293.298H99.6017V283.887Z",
    fill: "#F5F5F5"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M126.758 283.887H103.281V293.298H126.758V283.887Z",
    fill: "#E6E6E6"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M126.741 283.887H104.842V293.298H126.741V283.887Z",
    fill: "#F5F5F5"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6052 296.881H76.1289V306.292H99.6052V296.881Z",
    fill: "#E6E6E6"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6017 296.881H77.6875V306.292H99.6017V296.881Z",
    fill: "#F5F5F5"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M126.758 296.881H103.281V306.292H126.758V296.881Z",
    fill: "#E6E6E6"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M126.741 296.881H104.842V306.292H126.741V296.881Z",
    fill: "#F5F5F5"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6052 318.246H76.1289V327.658H99.6052V318.246Z",
    fill: "#E6E6E6"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6017 318.246H77.6875V327.658H99.6017V318.246Z",
    fill: "#F5F5F5"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M126.758 318.246H103.281V327.658H126.758V318.246Z",
    fill: "#E6E6E6"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M126.741 318.246H104.842V327.658H126.741V318.246Z",
    fill: "#F5F5F5"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6052 331.242H76.1289V340.654H99.6052V331.242Z",
    fill: "#E6E6E6"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6017 331.242H77.6875V340.654H99.6017V331.242Z",
    fill: "#F5F5F5"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M126.758 331.242H103.281V340.654H126.758V331.242Z",
    fill: "#E6E6E6"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M126.741 331.242H104.842V340.654H126.741V331.242Z",
    fill: "#F5F5F5"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6052 354.492H76.1289V363.904H99.6052V354.492Z",
    fill: "#E6E6E6"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6017 354.492H77.6875V363.904H99.6017V354.492Z",
    fill: "#F5F5F5"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M126.758 354.492H103.281V363.904H126.758V354.492Z",
    fill: "#E6E6E6"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M126.741 354.492H104.842V363.904H126.741V354.492Z",
    fill: "#F5F5F5"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6052 371.654H76.1289V381.066H99.6052V371.654Z",
    fill: "#E6E6E6"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6017 371.654H77.6875V381.066H99.6017V371.654Z",
    fill: "#F5F5F5"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M126.758 371.654H103.281V381.066H126.758V371.654Z",
    fill: "#E6E6E6"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M126.741 371.654H104.842V381.066H126.741V371.654Z",
    fill: "#F5F5F5"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M157.817 276.459H69.6348V278.083H157.817V276.459Z",
    fill: "black"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M157.817 311.451H69.6348V313.076H157.817V311.451Z",
    fill: "black"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M157.817 346.754H69.6348V348.366H157.817V346.754Z",
    fill: "black"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M157.804 223.746H65.4766V229.4H157.804V223.746Z",
    fill: "#E0E0E0"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M157.818 223.746H136.715V229.4H157.818V223.746Z",
    fill: "black"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M463.071 136.723H359.523V358.893H463.071V136.723Z",
    fill: "#E6E6E6"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M424.739 136.723H321.191V358.893H424.739V136.723Z",
    fill: "#F0F0F0"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M415.715 151.801H330.236V163.122H415.715V151.801Z",
    fill: "#E6E6E6"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M415.697 151.801H333.537V163.122H415.697V151.801Z",
    fill: "#F5F5F5"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M415.715 170.859H330.236V182.181H415.715V170.859Z",
    fill: "#E6E6E6"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M415.697 170.859H333.537V182.181H415.697V170.859Z",
    fill: "#F5F5F5"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M415.715 190.65H330.236V201.972H415.715V190.65Z",
    fill: "#E6E6E6"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M415.697 190.65H333.537V201.972H415.697V190.65Z",
    fill: "#F5F5F5"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M415.715 210.453H330.236V221.774H415.715V210.453Z",
    fill: "#E6E6E6"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M415.697 210.453H333.537V221.774H415.697V210.453Z",
    fill: "#F5F5F5"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M415.715 230.244H330.236V241.565H415.715V230.244Z",
    fill: "#E6E6E6"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M415.697 230.244H333.537V241.565H415.697V230.244Z",
    fill: "#F5F5F5"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M415.715 250.047H330.236V261.368H415.715V250.047Z",
    fill: "#E6E6E6"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M415.697 250.047H333.537V261.368H415.697V250.047Z",
    fill: "#F5F5F5"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M415.715 271.857H330.236V283.179H415.715V271.857Z",
    fill: "#E6E6E6"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M415.697 271.857H333.537V283.179H415.697V271.857Z",
    fill: "#F5F5F5"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M415.715 293.682H330.236V305.003H415.715V293.682Z",
    fill: "#E6E6E6"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M415.697 293.682H333.537V305.003H415.697V293.682Z",
    fill: "#F5F5F5"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M415.715 315.506H330.236V326.827H415.715V315.506Z",
    fill: "#E6E6E6"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M415.697 315.506H333.537V326.827H415.697V315.506Z",
    fill: "#F5F5F5"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M415.715 337.318H330.236V348.64H415.715V337.318Z",
    fill: "#E6E6E6"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M415.697 337.318H333.537V348.64H415.697V337.318Z",
    fill: "#F5F5F5"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M465.758 134.49H318.262V139.909H465.758V134.49Z",
    fill: "#E0E0E0"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M465.758 124.707H318.262V130.126H465.758V124.707Z",
    fill: "#E0E0E0"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M460.862 129.061H321.191V134.479H460.862V129.061Z",
    fill: "#F0F0F0"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M463.074 151.801H434.221V163.122H463.074V151.801Z",
    fill: "#E0E0E0"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M463.074 170.426H434.221V181.747H463.074V170.426Z",
    fill: "#E0E0E0"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M463.074 189.062H434.221V200.384H463.074V189.062Z",
    fill: "#E0E0E0"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M463.074 210.441H434.221V221.763H463.074V210.441Z",
    fill: "#E0E0E0"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M463.074 230.244H434.221V241.565H463.074V230.244Z",
    fill: "#E0E0E0"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M463.074 250.047H434.221V261.368H463.074V250.047Z",
    fill: "#E0E0E0"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M463.074 271.857H434.221V283.179H463.074V271.857Z",
    fill: "#E0E0E0"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M463.074 293.682H434.221V305.003H463.074V293.682Z",
    fill: "#E0E0E0"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M463.074 315.494H434.221V326.815H463.074V315.494Z",
    fill: "#E0E0E0"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M463.074 337.318H434.221V348.64H463.074V337.318Z",
    fill: "#E0E0E0"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M697.443 307.137H689.137V317.863H697.443V307.137Z",
    fill: "#E0E0E0"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M697.443 324.695H689.137V335.421H697.443V324.695Z",
    fill: "#E0E0E0"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M697.443 341.744H689.137V352.47H697.443V341.744Z",
    fill: "#E0E0E0"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M697.443 359.787H689.137V370.513H697.443V359.787Z",
    fill: "#E0E0E0"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M697.443 377.332H689.137V388.058H697.443V377.332Z",
    fill: "#E0E0E0"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M697.442 296.361H610.07V406.064H697.442V296.361Z",
    fill: "#E6E6E6"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M682.697 296.361H610.09V406.064H682.697V296.361Z",
    fill: "#F0F0F0"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M675.669 307.137H616.625V317.863H675.669V307.137Z",
    fill: "#EBEBEB"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M675.669 324.695H616.625V335.421H675.669V324.695Z",
    fill: "#EBEBEB"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M675.669 342.24H616.625V352.966H675.669V342.24Z",
    fill: "#EBEBEB"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M675.669 359.787H616.625V370.513H675.669V359.787Z",
    fill: "#EBEBEB"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M675.669 377.332H616.625V388.058H675.669V377.332Z",
    fill: "#EBEBEB"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M675.653 307.137H618.787V317.863H675.653V307.137Z",
    fill: "#F5F5F5"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M675.653 324.695H618.787V335.421H675.653V324.695Z",
    fill: "#F5F5F5"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M675.653 342.24H618.787V352.966H675.653V342.24Z",
    fill: "#F5F5F5"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M675.653 359.787H618.787V370.513H675.653V359.787Z",
    fill: "#F5F5F5"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M675.653 377.332H618.787V388.058H675.653V377.332Z",
    fill: "#F5F5F5"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M327.89 204.004H179.146V443.646H327.89V204.004Z",
    fill: "#0397D6"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M300.854 204.004H179.146V443.646H300.854V204.004Z",
    fill: "white"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M329.647 204.004H175.947V207.91H329.647V204.004Z",
    fill: "#0397D6"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M329.647 196.18H175.947V200.098H329.647V196.18Z",
    fill: "#0397D6"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M326.418 200.098H179.146V204.004H326.418V200.098Z",
    fill: "#F0F0F0"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M213.56 218.117H190.699V236.99H213.56V218.117Z",
    fill: "#0397D6"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M213.555 218.117H192.707V236.99H213.555V218.117Z",
    fill: "white"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M248.181 218.117H225.32V236.99H248.181V218.117Z",
    fill: "#0397D6"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M248.176 218.117H227.328V236.99H248.176V218.117Z",
    fill: "white"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M282.782 218.117H259.922V236.99H282.782V218.117Z",
    fill: "#0397D6"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M282.785 218.117H261.938V236.99H282.785V218.117Z",
    fill: "white"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M213.56 245.904H190.699V264.777H213.56V245.904Z",
    fill: "#0397D6"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M213.555 245.904H192.707V264.777H213.555V245.904Z",
    fill: "white"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M248.181 245.904H225.32V264.777H248.181V245.904Z",
    fill: "#0397D6"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M248.176 245.904H227.328V264.777H248.176V245.904Z",
    fill: "white"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M282.782 245.904H259.922V264.777H282.782V245.904Z",
    fill: "#0397D6"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M282.785 245.904H261.938V264.777H282.785V245.904Z",
    fill: "white"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M213.56 296.781H190.699V315.654H213.56V296.781Z",
    fill: "#0397D6"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M213.555 296.781H192.707V315.654H213.555V296.781Z",
    fill: "white"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M248.181 296.781H225.32V315.654H248.181V296.781Z",
    fill: "#0397D6"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M248.176 296.781H227.328V315.654H248.176V296.781Z",
    fill: "white"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M282.782 296.781H259.922V315.654H282.782V296.781Z",
    fill: "#0397D6"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M282.785 296.781H261.938V315.654H282.785V296.781Z",
    fill: "white"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M213.56 324.57H190.699V343.443H213.56V324.57Z",
    fill: "#0397D6"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M213.555 324.57H192.707V343.443H213.555V324.57Z",
    fill: "white"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M248.181 324.57H225.32V343.443H248.181V324.57Z",
    fill: "#0397D6"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M248.176 324.57H227.328V343.443H248.176V324.57Z",
    fill: "white"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M282.782 324.57H259.922V343.443H282.782V324.57Z",
    fill: "#0397D6"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M282.785 324.57H261.938V343.443H282.785V324.57Z",
    fill: "white"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M213.56 381.127H190.699V400H213.56V381.127Z",
    fill: "#0397D6"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M213.555 381.127H192.707V400H213.555V381.127Z",
    fill: "white"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M248.181 381.127H225.32V400H248.181V381.127Z",
    fill: "#0397D6"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M248.176 381.127H227.328V400H248.176V381.127Z",
    fill: "white"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M282.782 381.127H259.922V400H282.782V381.127Z",
    fill: "#0397D6"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M282.785 381.127H261.938V400H282.785V381.127Z",
    fill: "white"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M213.56 408.914H190.699V427.787H213.56V408.914Z",
    fill: "#0397D6"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M213.555 408.914H192.707V427.787H213.555V408.914Z",
    fill: "white"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M248.181 408.914H225.32V427.787H248.181V408.914Z",
    fill: "#0397D6"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M248.176 408.914H227.328V427.787H248.176V408.914Z",
    fill: "white"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M282.782 408.914H259.922V427.787H282.782V408.914Z",
    fill: "#0397D6"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M282.785 408.914H261.938V427.787H282.785V408.914Z",
    fill: "white"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M327.89 278.045H179.146V279.793H327.89V278.045Z",
    fill: "white"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M327.89 365.02H179.146V366.768H327.89V365.02Z",
    fill: "white"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M532.688 236.988H429.816V443.647H532.688V236.988Z",
    fill: "#0397D6"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M508.071 236.988H429.816V443.647H508.071V236.988Z",
    fill: "white"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M464.782 253.965H437.4V264.939H464.782V253.965Z",
    fill: "#0397D6"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M464.779 253.965H439.215V264.939H464.779V253.965Z",
    fill: "white"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M496.458 253.965H469.076V264.939H496.458V253.965Z",
    fill: "#0397D6"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M496.459 253.965H470.895V264.939H496.459V253.965Z",
    fill: "white"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M464.782 274.623H437.4V285.597H464.782V274.623Z",
    fill: "#0397D6"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M464.779 274.623H439.215V285.597H464.779V274.623Z",
    fill: "white"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M496.458 274.623H469.076V285.597H496.458V274.623Z",
    fill: "#0397D6"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M496.459 274.623H470.895V285.597H496.459V274.623Z",
    fill: "white"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M464.782 301.023H437.4V311.997H464.782V301.023Z",
    fill: "#0397D6"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M464.779 301.023H439.215V311.997H464.779V301.023Z",
    fill: "white"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M496.458 301.023H469.076V311.997H496.458V301.023Z",
    fill: "#0397D6"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M496.459 301.023H470.895V311.997H496.459V301.023Z",
    fill: "white"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M464.782 316.188H437.4V327.162H464.782V316.188Z",
    fill: "#0397D6"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M464.779 316.188H439.215V327.162H464.779V316.188Z",
    fill: "white"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M496.458 316.188H469.076V327.162H496.458V316.188Z",
    fill: "#0397D6"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M496.459 316.188H470.895V327.162H496.459V316.188Z",
    fill: "white"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M464.782 341.111H437.4V352.085H464.782V341.111Z",
    fill: "#0397D6"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M464.779 341.111H439.215V352.085H464.779V341.111Z",
    fill: "white"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M496.458 341.111H469.076V352.085H496.458V341.111Z",
    fill: "#0397D6"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M496.459 341.111H470.895V352.085H496.459V341.111Z",
    fill: "white"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M464.782 356.277H437.4V367.251H464.782V356.277Z",
    fill: "#0397D6"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M464.779 356.277H439.215V367.251H464.779V356.277Z",
    fill: "white"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M496.458 356.277H469.076V367.251H496.458V356.277Z",
    fill: "#0397D6"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M496.459 356.277H470.895V367.251H496.459V356.277Z",
    fill: "white"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M464.782 383.395H437.4V394.369H464.782V383.395Z",
    fill: "#0397D6"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M464.779 383.395H439.215V394.369H464.779V383.395Z",
    fill: "white"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M496.458 383.395H469.076V394.369H496.458V383.395Z",
    fill: "#0397D6"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M496.459 383.395H470.895V394.369H496.459V383.395Z",
    fill: "white"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M464.782 403.434H437.4V414.408H464.782V403.434Z",
    fill: "#0397D6"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M464.779 403.434H439.215V414.408H464.779V403.434Z",
    fill: "white"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M496.458 403.434H469.076V414.408H496.458V403.434Z",
    fill: "#0397D6"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M496.459 403.434H470.895V414.408H496.459V403.434Z",
    fill: "white"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M532.702 230.875H424.979V237.472H532.702V230.875Z",
    fill: "#0397D6"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M532.704 230.875H508.086V237.472H532.704V230.875Z",
    fill: "black"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M429.819 328.24H420.131V340.752H429.819V328.24Z",
    fill: "#E0E0E0"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M429.819 348.713H420.131V361.224H429.819V348.713Z",
    fill: "#E0E0E0"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M429.819 368.615H420.131V381.127H429.819V368.615Z",
    fill: "#E0E0E0"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M429.819 389.658H420.131V402.17H429.819V389.658Z",
    fill: "#E0E0E0"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M429.819 410.129H420.131V422.641H429.819V410.129Z",
    fill: "#E0E0E0"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M429.816 315.668H327.891V443.648H429.816V315.668Z",
    fill: "#0397D6"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M412.603 315.654H327.891V443.647H412.603V315.654Z",
    fill: "white"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M404.386 328.24H335.504V340.752H404.386V328.24Z",
    fill: "#0397D6"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M404.386 348.713H335.504V361.224H404.386V348.713Z",
    fill: "#0397D6"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M404.386 369.186H335.504V381.697H404.386V369.186Z",
    fill: "#0397D6"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M404.386 389.658H335.504V402.17H404.386V389.658Z",
    fill: "#0397D6"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M404.386 410.129H335.504V422.641H404.386V410.129Z",
    fill: "#0397D6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M404.384 328.24H338.041V340.752H404.384V328.24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M404.384 348.713H338.041V361.224H404.384V348.713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M404.384 369.186H338.041V381.697H404.384V369.186Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M404.384 389.656H338.041V402.168H404.384V389.656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M404.384 410.129H338.041V422.641H404.384V410.129Z",
    fill: "white"
  }))), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M118.031 354.975H49.6445V443.647H158.78V354.975V315.654L118.031 354.975Z",
    fill: "#0397D6"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M179.144 315.654H158.777V443.647H179.144V315.654Z",
    fill: "#0397D6"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M179.144 315.654H158.777V443.647H179.144V315.654Z",
    fill: "white"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M327.893 207.91H300.842V443.647H327.893V207.91Z",
    fill: "white"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M429.814 315.654H412.602V443.647H429.814V315.654Z",
    fill: "white"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M532.704 237.473H508.086V443.647H532.704V237.473Z",
    fill: "white"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M547.108 202.047H543.232V215.253H547.108V202.047Z",
    fill: "white"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M547.108 224.266H543.232V237.472H547.108V224.266Z",
    fill: "white"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M547.108 247.367H543.232V260.573H547.108V247.367Z",
    fill: "white"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M547.108 270.469H543.232V283.675H547.108V270.469Z",
    fill: "white"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M547.108 293.559H543.232V306.765H547.108V293.559Z",
    fill: "white"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M547.108 316.66H543.232V329.866H547.108V316.66Z",
    fill: "white"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M547.108 342.117H543.232V355.323H547.108V342.117Z",
    fill: "white"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M547.108 367.574H543.232V380.78H547.108V367.574Z",
    fill: "white"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M547.108 393.02H543.232V406.226H547.108V393.02Z",
    fill: "white"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M547.108 418.477H543.232V431.683H547.108V418.477Z",
    fill: "white"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M698.222 184.449H577.416V443.646H698.222V184.449Z",
    fill: "#0397D6"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M653.495 184.449H532.689V443.646H653.495V184.449Z",
    fill: "#0397D6"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M698.218 188.17H653.504V443.647H698.218V188.17Z",
    fill: "white"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M698.224 202.047H664.564V215.253H698.224V202.047Z",
    fill: "#0397D6"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M698.224 223.77H664.564V236.976H698.224V223.77Z",
    fill: "#0397D6"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M698.224 245.508H664.564V258.714H698.224V245.508Z",
    fill: "#0397D6"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M698.224 270.457H664.564V283.663H698.224V270.457Z",
    fill: "#0397D6"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M698.224 293.559H664.564V306.765H698.224V293.559Z",
    fill: "#0397D6"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M698.224 316.66H664.564V329.866H698.224V316.66Z",
    fill: "#0397D6"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M698.224 342.104H664.564V355.31H698.224V342.104Z",
    fill: "#0397D6"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M698.224 367.561H664.564V380.767H698.224V367.561Z",
    fill: "#0397D6"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M698.224 393.02H664.564V406.226H698.224V393.02Z",
    fill: "#0397D6"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M698.224 418.477H664.564V431.683H698.224V418.477Z",
    fill: "#0397D6"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M698.224 202.047H664.564V215.253H698.224V202.047Z",
    fill: "white"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M698.224 223.77H664.564V236.976H698.224V223.77Z",
    fill: "white"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M698.224 245.508H664.564V258.714H698.224V245.508Z",
    fill: "white"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M698.224 270.457H664.564V283.663H698.224V270.457Z",
    fill: "white"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M698.224 293.559H664.564V306.765H698.224V293.559Z",
    fill: "white"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M698.224 316.66H664.564V329.866H698.224V316.66Z",
    fill: "white"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M698.224 342.104H664.564V355.31H698.224V342.104Z",
    fill: "white"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M698.224 367.561H664.564V380.767H698.224V367.561Z",
    fill: "white"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M698.224 393.02H664.564V406.226H698.224V393.02Z",
    fill: "white"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M698.224 418.477H664.564V431.683H698.224V418.477Z",
    fill: "white"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M653.495 184.449H532.689V443.646H653.495V184.449Z",
    fill: "white"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M642.965 202.047H543.232V215.253H642.965V202.047Z",
    fill: "#0397D6"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M642.965 202.047H547.107V215.253H642.965V202.047Z",
    fill: "white"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M642.965 224.266H543.232V237.472H642.965V224.266Z",
    fill: "#0397D6"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M642.965 224.266H547.107V237.472H642.965V224.266Z",
    fill: "white"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M642.965 247.367H543.232V260.573H642.965V247.367Z",
    fill: "#0397D6"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M642.965 247.367H547.107V260.573H642.965V247.367Z",
    fill: "white"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M642.965 270.469H543.232V283.675H642.965V270.469Z",
    fill: "#0397D6"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M642.965 270.469H547.107V283.675H642.965V270.469Z",
    fill: "white"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M642.965 293.559H543.232V306.765H642.965V293.559Z",
    fill: "#0397D6"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M642.965 293.559H547.107V306.765H642.965V293.559Z",
    fill: "white"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M642.965 316.66H543.232V329.866H642.965V316.66Z",
    fill: "#0397D6"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M642.965 316.66H547.107V329.866H642.965V316.66Z",
    fill: "white"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M642.965 342.117H543.232V355.323H642.965V342.117Z",
    fill: "#0397D6"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M642.965 342.117H547.107V355.323H642.965V342.117Z",
    fill: "white"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M642.965 367.574H543.232V380.78H642.965V367.574Z",
    fill: "#0397D6"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M642.965 367.574H547.107V380.78H642.965V367.574Z",
    fill: "white"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M642.965 393.02H543.232V406.226H642.965V393.02Z",
    fill: "#0397D6"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M642.965 393.02H547.107V406.226H642.965V393.02Z",
    fill: "white"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M642.965 418.477H543.232V431.683H642.965V418.477Z",
    fill: "#0397D6"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M642.965 418.477H547.107V431.683H642.965V418.477Z",
    fill: "white"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M695.635 176.75H653.504V181.834H695.635V176.75Z",
    fill: "#0397D6"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M695.641 175.51H532.689V181.834H695.641V175.51Z",
    fill: "#F0F0F0"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M701.363 181.848H529.279V188.172H701.363V181.848Z",
    fill: "#0397D6"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M701.363 170.426H529.279V176.75H701.363V170.426Z",
    fill: "#0397D6"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M701.363 181.848H529.279V188.172H701.363V181.848Z",
    fill: "black"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M701.363 170.426H529.279V176.75H701.363V170.426Z",
    fill: "black"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M532.688 292.059H429.816V293.943H532.688V292.059Z",
    fill: "white"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M532.688 332.891H429.816V334.775H532.688V332.891Z",
    fill: "white"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M532.688 374.07H429.816V375.955H532.688V374.07Z",
    fill: "white"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M329.635 204.004H300.842V207.91H329.635V204.004Z",
    fill: "black"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M329.635 196.18H300.842V200.086H329.635V196.18Z",
    fill: "black"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M701.358 181.848H653.504V188.172H701.358V181.848Z",
    fill: "black"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M701.358 170.426H653.504V176.75H701.358V170.426Z",
    fill: "black"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M118.031 354.975H49.6445V443.647H158.78V354.975V315.654L118.031 354.975Z",
    fill: "white"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7815 372.955H59.5449V386.359H75.7815V372.955Z",
    fill: "#0397D6"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M108.826 372.955H92.5898V386.359H108.826V372.955Z",
    fill: "#0397D6"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M141.867 372.955H125.631V386.359H141.867V372.955Z",
    fill: "#0397D6"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7815 395.512H59.5449V408.916H75.7815V395.512Z",
    fill: "#0397D6"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M108.826 395.512H92.5898V408.916H108.826V395.512Z",
    fill: "#0397D6"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M141.867 395.512H125.631V408.916H141.867V395.512Z",
    fill: "#0397D6"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7815 418.066H59.5449V431.471H75.7815V418.066Z",
    fill: "#0397D6"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M108.826 418.066H92.5898V431.471H108.826V418.066Z",
    fill: "#0397D6"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M141.867 418.066H125.631V431.471H141.867V418.066Z",
    fill: "#0397D6"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M77.5823 372.955H61.3457V386.359H77.5823V372.955Z",
    fill: "white"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M110.608 372.955H94.3711V386.359H110.608V372.955Z",
    fill: "white"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M143.655 372.955H127.418V386.359H143.655V372.955Z",
    fill: "white"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M77.5823 395.512H61.3457V408.916H77.5823V395.512Z",
    fill: "white"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M110.608 395.512H94.3711V408.916H110.608V395.512Z",
    fill: "white"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M143.655 395.512H127.418V408.916H143.655V395.512Z",
    fill: "white"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M77.5823 418.066H61.3457V431.471H77.5823V418.066Z",
    fill: "white"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M110.608 418.066H94.3711V431.471H110.608V418.066Z",
    fill: "white"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M143.655 418.066H127.418V431.471H143.655V418.066Z",
    fill: "white"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M366.645 453.928L357.242 493.31H388.799L385.6 453.928H366.645Z",
    fill: "#4AAA42"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M396.143 453.928L409.661 493.31H430.809L413.476 453.928H396.143Z",
    fill: "#4AAA42"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M425.369 453.928L453.186 493.31H477.188L441.035 453.928H425.369Z",
    fill: "#4AAA42"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M453.594 453.928L499.69 493.31H528.393L470.792 453.928H453.594Z",
    fill: "#4AAA42"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M354.865 453.928L341.347 493.31H320.199L337.532 453.928H354.865Z",
    fill: "#4AAA42"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M325.639 453.928L297.822 493.31H273.82L309.973 453.928H325.639Z",
    fill: "#4AAA42"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M297.415 453.928L251.318 493.31H222.615L280.217 453.928H297.415Z",
    fill: "#4AAA42"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M366.645 453.928L357.242 493.31H388.799L385.6 453.928H366.645Z",
    fill: "white"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M396.143 453.928L409.661 493.31H430.809L413.476 453.928H396.143Z",
    fill: "white"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M425.369 453.928L453.186 493.31H477.188L441.035 453.928H425.369Z",
    fill: "white"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M453.594 453.928L499.69 493.31H528.393L470.792 453.928H453.594Z",
    fill: "white"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M354.865 453.928L341.347 493.31H320.199L337.532 453.928H354.865Z",
    fill: "white"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M325.639 453.928L297.822 493.31H273.82L309.973 453.928H325.639Z",
    fill: "white"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M297.415 453.928L251.318 493.31H222.615L280.217 453.928H297.415Z",
    fill: "white"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M151.197 439.096C156.725 438.934 162.15 437.823 167.128 435.833C172.106 433.843 176.527 431.019 180.108 427.539C183.69 424.06 186.353 420.002 187.929 415.625C189.504 411.249 189.957 406.649 189.258 402.119C188.267 395.659 184.992 389.62 182.679 383.395C178.309 371.628 176.912 358.347 166.878 349.233C163.782 346.43 160.011 344.191 155.807 342.659C151.603 341.127 147.059 340.336 142.463 340.336C137.868 340.336 133.323 341.127 129.119 342.659C124.915 344.191 121.145 346.43 118.048 349.233C111.545 355.123 108.466 363.084 107.129 370.983C105.792 378.882 105.972 386.88 105.146 394.778C104.395 401.363 102.878 407.935 103.209 414.544C103.539 421.153 105.942 428.035 111.815 432.536C114.813 434.646 118.162 436.392 121.758 437.72C125.221 439.311 128.975 440.425 132.873 441.018C134.826 441.304 136.832 441.224 138.743 440.784C140.654 440.344 142.421 439.555 143.913 438.476C146.291 438.974 148.746 439.183 151.197 439.096Z",
    fill: "#4AAA42"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M151.197 439.096C156.725 438.934 162.15 437.823 167.128 435.833C172.106 433.843 176.527 431.019 180.108 427.539C183.69 424.06 186.353 420.002 187.929 415.625C189.504 411.249 189.957 406.649 189.258 402.119C188.267 395.659 184.992 389.62 182.679 383.395C178.309 371.628 176.912 358.347 166.878 349.233C163.782 346.43 160.011 344.191 155.807 342.659C151.603 341.127 147.059 340.336 142.463 340.336C137.868 340.336 133.323 341.127 129.119 342.659C124.915 344.191 121.145 346.43 118.048 349.233C111.545 355.123 108.466 363.084 107.129 370.983C105.792 378.882 105.972 386.88 105.146 394.778C104.395 401.363 102.878 407.935 103.209 414.544C103.539 421.153 105.942 428.035 111.815 432.536C114.813 434.646 118.162 436.392 121.758 437.72C125.221 439.311 128.975 440.425 132.873 441.018C134.826 441.304 136.832 441.224 138.743 440.784C140.654 440.344 142.421 439.555 143.913 438.476C146.291 438.974 148.746 439.183 151.197 439.096Z",
    fill: "white"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M132.83 463.14V461.491L136.149 459.172C136.149 459.172 140.115 425.692 140.791 415.996C141.467 406.299 142.293 391.022 137.967 379.936C141.799 387.495 144.527 395.405 146.093 403.496C146.093 403.496 151.23 388.244 160.347 378.535C160.347 378.535 149.232 401.971 150.734 423.77C151.483 436.158 153.366 448.482 156.366 460.636L158.349 461.727L158.514 463.103L132.83 463.14Z",
    fill: "#4AAA42"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M142.969 409.35C142.969 409.35 140.086 398.786 132.32 393.553C132.32 393.553 138.824 400.993 140.957 413.492C143.09 425.991 145.358 418.055 145.358 418.055L142.969 409.35Z",
    fill: "#4AAA42"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M139.573 437.932C138.648 435.34 136.58 433.127 133.775 431.732C133.775 431.732 136.779 434.113 138.161 441.739C139.543 449.365 142.998 445.162 142.998 445.162L143.268 440.958L139.573 437.932Z",
    fill: "#4AAA42"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M138.19 441.726C136.688 434.1 133.805 431.719 133.805 431.719C135.941 432.808 137.668 434.367 138.791 436.221C139.692 428.099 140.534 420.001 140.819 415.996C140.819 415.203 140.924 414.359 140.969 413.516C138.836 400.967 132.348 393.577 132.348 393.577C136.854 396.615 139.722 401.463 141.36 404.985C141.495 396.727 140.909 387.402 138.025 379.962C141.857 387.521 144.585 395.43 146.151 403.522C146.151 403.522 151.288 388.27 160.405 378.561C160.405 378.561 149.29 401.997 150.792 423.796C151.541 436.184 153.424 448.507 156.425 460.661L158.407 461.752L158.573 463.129H132.828V461.479L136.148 459.161C136.148 459.161 137.094 451.088 138.19 441.726Z",
    fill: "black"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M593.623 444.404C587.383 444.22 581.258 442.964 575.639 440.716C570.02 438.469 565.03 435.279 560.987 431.351C556.944 427.423 553.936 422.842 552.157 417.901C550.377 412.96 549.864 407.767 550.651 402.653C551.777 395.362 555.472 388.542 558.086 381.573C563.027 368.281 564.605 353.289 575.93 343.009C579.422 339.843 583.677 337.313 588.422 335.582C593.166 333.851 598.296 332.957 603.484 332.957C608.671 332.957 613.801 333.851 618.546 335.582C623.291 337.313 627.546 339.843 631.038 343.009C638.383 349.643 641.867 358.646 643.385 367.549C644.902 376.452 644.661 385.492 645.668 394.457C646.509 401.897 648.221 409.337 647.86 416.777C647.5 424.217 644.766 432.004 638.142 437.101C634.736 439.491 630.932 441.466 626.847 442.966C622.936 444.764 618.694 446.02 614.291 446.686C612.084 447.009 609.818 446.919 607.66 446.421C605.502 445.923 603.507 445.03 601.824 443.809C599.14 444.336 596.377 444.537 593.623 444.404Z",
    fill: "#4AAA42"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M593.623 444.404C587.383 444.22 581.258 442.964 575.639 440.716C570.02 438.469 565.03 435.279 560.987 431.351C556.944 427.423 553.936 422.842 552.157 417.901C550.377 412.96 549.864 407.767 550.651 402.653C551.777 395.362 555.472 388.542 558.086 381.573C563.027 368.281 564.605 353.289 575.93 343.009C579.422 339.843 583.677 337.313 588.422 335.582C593.166 333.851 598.296 332.957 603.484 332.957C608.671 332.957 613.801 333.851 618.546 335.582C623.291 337.313 627.546 339.843 631.038 343.009C638.383 349.643 641.867 358.646 643.385 367.549C644.902 376.452 644.661 385.492 645.668 394.457C646.509 401.897 648.221 409.337 647.86 416.777C647.5 424.217 644.766 432.004 638.142 437.101C634.736 439.491 630.932 441.466 626.847 442.966C622.936 444.764 618.694 446.02 614.291 446.686C612.084 447.009 609.818 446.919 607.66 446.421C605.502 445.923 603.507 445.03 601.824 443.809C599.14 444.336 596.377 444.537 593.623 444.404Z",
    fill: "white"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M614.324 471.537V469.689L610.584 467.06C610.584 467.06 606.078 429.228 605.342 418.328C604.606 407.429 603.66 390.131 608.527 377.619C604.203 386.16 601.132 395.098 599.379 404.242C599.379 404.242 593.582 387.031 583.293 376.057C583.293 376.057 595.835 402.518 594.152 427.132C593.295 441.108 591.166 455.01 587.784 468.722L585.546 469.962L585.351 471.499L614.324 471.537Z",
    fill: "#4AAA42"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M602.906 410.826C602.906 410.826 606.15 398.897 614.922 392.982C614.922 392.982 607.577 401.328 605.174 415.501C602.771 429.674 600.188 420.634 600.188 420.634L602.906 410.826Z",
    fill: "#4AAA42"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M606.813 443.091C607.854 440.156 610.191 437.652 613.362 436.072C613.362 436.072 610.012 438.763 608.42 447.369C606.828 455.974 602.938 451.188 602.938 451.188L602.652 446.451L606.813 443.091Z",
    fill: "#4AAA42"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M608.316 447.369C609.908 438.763 613.258 436.073 613.258 436.073C610.834 437.295 608.877 439.057 607.61 441.157C606.604 431.993 605.658 422.842 605.342 418.328C605.342 417.423 605.222 416.468 605.162 415.489C607.565 401.328 614.91 392.983 614.91 392.983C609.803 396.417 606.574 401.886 604.757 405.866C604.606 396.541 605.267 386.026 608.527 377.619C604.203 386.16 601.132 395.098 599.379 404.242C599.379 404.242 593.582 387.031 583.293 376.057C583.293 376.057 595.835 402.518 594.152 427.132C593.295 441.108 591.166 455.01 587.784 468.722L585.546 469.962L585.351 471.499H614.324V469.652L610.584 467.023C610.584 467.023 609.533 457.946 608.316 447.369Z",
    fill: "black"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M697 201C710.261 201 722.979 195.732 732.355 186.355C741.732 176.979 747 164.261 747 151C747 137.739 741.732 125.021 732.355 115.645C722.979 106.268 710.261 101 697 101C683.739 101 671.021 106.268 661.645 115.645C652.268 125.021 647 137.739 647 151C647 164.261 652.268 176.979 661.645 186.355C671.021 195.732 683.739 201 697 201ZM720.169 142.919C721.307 141.74 721.937 140.161 721.923 138.522C721.909 136.884 721.251 135.316 720.093 134.157C718.934 132.999 717.366 132.341 715.728 132.327C714.089 132.313 712.51 132.943 711.331 134.081L690.75 154.663L682.669 146.581C681.49 145.443 679.911 144.813 678.272 144.827C676.634 144.841 675.066 145.499 673.907 146.657C672.749 147.816 672.091 149.384 672.077 151.022C672.063 152.661 672.693 154.24 673.831 155.419L686.331 167.919C687.503 169.09 689.093 169.749 690.75 169.749C692.407 169.749 693.997 169.09 695.169 167.919L720.169 142.919Z",
    fill: "#0397D6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectImage);
export default __webpack_public_path__ + "static/media/project_image.4e6269dcf57cdb39c6a020a60565cc71.svg";
export { ForwardRef as ReactComponent };